export default {
  SET_RESOURCE_INFO (state, val) {
    state.resourceInfo = val
  },
  SET_OA_QUERY (state, val) {
    state.oaQuery = val
  },
  SET_OA_ZJ_INFO (state, val) {
    state.oaZjInfo = val
  },
}
